import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type CookieState = {
  hasAgreed: boolean;
  isLoading: boolean;
};

type CookieActions = {
  acceptCookies: (value: boolean) => void;
  toggleLoading: (value: boolean) => void;
};

type CookieStore = CookieState & CookieActions;

export const useCookieAgreements = create<CookieStore>()(
  persist(
    (set) => ({
      hasAgreed: false,
      isLoading: true,
      acceptCookies: (value) => set({ hasAgreed: value }),
      toggleLoading: (value) => set({ isLoading: value }),
    }),
    {
      name: "cookie-agreements",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ hasAgreed: state.hasAgreed }),
      onRehydrateStorage: () => (state) => {
        state?.toggleLoading(false);
      },
    }
  )
);
